import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(
        `${BACKEND_URL}/api/admin/login`,
        { password },
        { withCredentials: true }
      );
      toast.success('Admin login successful');
      navigate('/admin');
    } catch (error) {
      toast.error('Invalid admin password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 border-2 border-primary rounded-full mb-4">
            <Shield className="text-primary" size={40} />
          </div>
          <h1 className="font-heading font-black text-4xl mb-2">
            ADMIN <span className="text-primary">ACCESS</span>
          </h1>
          <p className="text-zinc-400">MSF Racing Fantasy League</p>
        </div>

        <div className="bg-card border border-zinc-800 p-8">
          <h2 className="font-heading font-bold text-2xl mb-6">Enter Admin Password</h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-zinc-400 mb-2">
                Admin Password
              </label>
              <input
                type="password"
                data-testid="admin-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-zinc-950 border border-zinc-800 focus:border-primary focus:ring-1 focus:ring-primary h-12 px-4 text-white"
                placeholder="Enter admin password"
                required
                autoFocus
              />
            </div>
            
            <button
              type="submit"
              data-testid="admin-login-button"
              disabled={loading}
              className="w-full btn-skew bg-primary text-white py-3 font-heading font-bold uppercase tracking-wider neon-glow-hover disabled:opacity-50"
            >
              <span>{loading ? 'Logging in...' : 'Access Admin Panel'}</span>
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm text-zinc-400 hover:text-primary transition-colors"
            >
              Back to Player Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
